export const moduleName = 'window'

export const OPEN_WINDOW = `${moduleName}/OPEN_WINDOW`
export const CLOSE_WINDOW = `${moduleName}/CLOSE_WINDOW`
